module.exports = (__webpack_require__("dll-reference pcxbase"))("./core/router.js");